import { useState } from 'react';
import api from '../api';
import './Login.css';

const MODULES = [
  'Savings & Loans',
  'ROSCA Cash Rounds',
  'Your MIFL Ledger',
  'Bereavement Support',
];

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { username, password });
      onLogin(res.data.token, res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kams-login">

      <div className="kams-login__letterhead">
        <h1>KIGEZI ASSOCIATION</h1>
        <p>KAMS &mdash; Kigezi Association Management System</p>
      </div>

      <div className="kams-login__modules">
        {MODULES.map((m) => (
          <div className="kams-login__module" key={m}>
            <span className="kams-login__module-dot" aria-hidden="true" />
            {m}
          </div>
        ))}
      </div>

      <div className="kams-login__main">
        <div className="kams-login__card">
          <h2>Welcome back</h2>
          <div className="kams-login__ruleline" aria-hidden="true" />
          <p className="kams-login__subtext">Sign in to manage your savings, loans, and membership records.</p>

          {error && (
            <div className="kams-login__error" role="alert">
              <span>&#9888;</span>
              <span><strong>We couldn't sign you in.</strong> {error}</span>
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="kams-login__field">
              <label htmlFor="username">Username</label>
              <div className="kams-login__inputwrap">
                <input
                  id="username"
                  type="text"
                  autoComplete="off"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="kams-login__field">
              <label htmlFor="password">Password</label>
              <div className="kams-login__inputwrap">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="off"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="kams-login__toggle-pw"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? 'HIDE' : 'SHOW'}
                </button>
              </div>
            </div>

            <button type="submit" className="kams-login__submit" disabled={loading}>
              {loading && <span className="kams-login__spinner" aria-hidden="true" />}
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>

          <div className="kams-login__footer">
            <span>KAMS &middot; {new Date().getFullYear()}</span>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Login;